import { Component } from 'react';
import {validateImpersonationURL} from "../../shared/urls/clientapi";
import {loginURL, homeURL} from "../../shared/urls/app";
import {callService, GET} from "../../shared/serviceInvoker";
import {signOut} from "../../shared/auth";

export default class Impersonate extends Component {

    constructor(props) {
        super(props);
        if (this.props.match && this.props.match.params) {
            var contact_id = this.props.match.params.contactID; 
            callService(
                GET,
                validateImpersonationURL.replace('{contact_id}', contact_id),
                null,
                response => {
                    var result = response.data.data;
                    sessionStorage.setItem('isImpersonating', 'true');
                    sessionStorage.setItem('isUserAuthenticated', 'true');
                    sessionStorage.setItem('first_name', result.first_name);
                    sessionStorage.setItem('contact_id', result.contact_id);    
                    sessionStorage.setItem('user_id', result.user_id);
                    sessionStorage.setItem('full_name', result.full_name);
                    sessionStorage.setItem("autoplay_launched", 'false');           
                    this.props.history.push(homeURL);
                },
                error => {
                    signOut();
                    this.props.history.push(loginURL);
                }
            );
        } else {
            this.props.history.push(homeURL);           
        }
        
    }

    render() {
        return (null);
    }
}



// WEBPACK FOOTER //
// ./src/components/Impersonate/index.js